function waitForEl(selector, callback, maxtries = false, interval = 100) {
  const poller = setInterval(() => {
    const el = jQuery(selector);
    const retry = maxtries === false || maxtries-- > 0;
    if (retry && el.length < 1) return; // will try again
    clearInterval(poller);
    callback(el || null);
  }, interval);
};

class ProductParent {
  constructor(container) {
    this.container = container;
    this.collectionHandle = this.container.getAttribute(
      "data-collection-handle"
    );
    this.$submitBtn = $("#add-to-cart-variant-button");
    this.savedWishList = {};
    // Only update the URL query params when we're ready, e.g. a user clicks
    this.updateUrlAllowed = false;

    this.getProductData((data) => {
      this.tabs = data.tabs;
      this.variants = data.variants;
      let currentVariantId = this.getUrlParameter("variant");
      let group = this.getUrlParameter("group");
      if (currentVariantId) {
        this.selectedVariant = Object.values(this.variants).find(
          (variant) => variant.id.toString() === currentVariantId.toString()
        );
        // only select variants that have images and are available.
        if (this.selectedVariant) {
          let swatch = this.tabs[this.selectedVariant.tab].swatches[
            this.selectedVariant.swatch
          ];
          if (swatch.images.length === 0 || !swatch.available) {
            this.selectedVariant = null;
          }
        }
      } else if (group) {
        this.selectedGroup = group;
      }
      this.buildPage();
      if (this.selectedVariant) {
        window.scrollToSwatch(this.getSwatchSlug(this.selectedVariant.swatch));
      }
    });

    this.addListeners();
  }

  buildPage() {
    let that = this;
    let length = 0;
    Object.values(this.tabs).forEach((tab, index) => {
      let $tab = $(`
          <button
              type="button"
              color-tab-opener="${tab.handle}"
              class="color-swatch__tab-opener">
              ${tab.name}
          </button>
      `);
      length++;
      $("#swatch-tabs").append($tab);
      // Check if NOT deeped linked to a variant or Group:
      // select the first tab (index 0)
      if (index === 0 && !this.selectedVariant && !this.selectedGroup) {
        this.updateTab(tab.handle);
        // Check if not deeped linked to a variant or Group:
      } else if (
        this.selectedVariant &&
        this.selectedVariant.tab === tab.handle
      ) {
        this.updateTab(tab.handle);
      } else if (this.selectedGroup) {
        this.updateTab(this.selectedGroup);
      }
      $tab.on("click", function (event) {
        let $this = $(this); //clicked on tab opener
        event.stopPropagation();
        that.selectedVariant = null;
        let tabHandle = $this.attr("color-tab-opener"); //current color grouping ID
        //that.openTab(tabId, true)
        that.updateTab(tabHandle);
      });
    });
    // Hide the tabs if there is only one tab
    if (length <= 1) {
      $("#swatch-tabs").hide();
      $(".color-swatch__tab-header").hide();
    }
    this.listCategories();
  }

  updateTab(tabHandle, clickFirstSwatch) {
    if (!this.tabs[tabHandle]) {
      return;
    }
    $(".color-swatch__tab-opener").removeClass("active");
    $(`.color-swatch__tab-opener[color-tab-opener="${tabHandle}"]`).addClass(
      "active"
    );

    if (clickFirstSwatch) {
      const $firstLabel = $thisTabVariantContainer
        .find("li")
        .first()
        .find("label");
      $firstLabel.trigger("click");
    }

    this.makeSizes(Object.values(this.tabs[tabHandle].sizes));
    this.showSwatches(this.tabs[tabHandle].swatches, tabHandle);

    //get current variant id
    let regex = new RegExp("[\\?&]variant=([^&#]*)");
    let results = regex.exec(location.search);
    if (results !== null) {
      let currentVariantId = decodeURIComponent(results[1].replace(/\+/g, " "));

      //reset inventory message
      let inventory_item = $(".inventory-container").find(
        "[data-id='" + currentVariantId + "']"
      );
      let inventoryDiv = $(inventory_item[0]).clone();
      $(".inventory-alternate").html(inventoryDiv);
    }

    // update print collection
    let $selectedSwatchInput = $("input[name='color-input']:checked");
    let $selectedSwatchInputColor = $selectedSwatchInput.val();

    //---------remove print collection content
    $(".product-print-collection__wrapper").hide();
    $(".product-print-collection-body").owlCarousel("destroy");
    $(".product-print-collection-body").empty();

    if (window.print_products) {
      let print_product_limit = 4;
      let iterator = 1;

      //---------draw print collection content
      window.print_products.every(function (print_product) {
        if (iterator > print_product_limit) {
          return false;
        }

        print_product_slug = print_product.slug;

        print_product.variants.every(function (variant) {
          if (
            variant.option1 == $selectedSwatchInputColor &&
            variant.id != currentVariantId
          ) {
            iterator++;

            let productLink =
              "/products/" + print_product_slug + "?variant=" + variant.id;

            $(".product-print-collection-body").append(`
            <div class="product-print-collection_item">
              <a href="${productLink}">
                <div class="product-print-collection_item_image" style="background-image: url(${Shopify.resizeImage(
              variant.featured_image_src,
              "x200"
            )})"></div>
                
                <div class="product-print-collection_item_content">
                  <div class="product-print-collection_item_title">
                    ${print_product.title}
                  </div>

                  <div class="product-print-collection_item_price">
                    ${Shopify.formatMoney(variant.price)}
                  </div>
                </div>
              </a>
            </div>
          `);

            $(".product-print-collection__wrapper").show();

            return false;
          }

          return true;
        });

        return true;
      });

      let owlConfig = {
        items: 4,
        autoWidth: false,
        lazyLoad: true,
        loop: true,
        margin: 30,
        nav: true,
        dots: false,
        responsive: {
          0: {
            items: 1,
          },
          375: {
            items: 2,
            margin: 60,
          },
          767: {
            items: 3,
          },
          992: {
            items: 4,
          },
        },
      };

      $(".product-print-collection-body").owlCarousel(owlConfig);
    }
  }

  showSwatches(swatches, tabHandle) {
    console.log('swatches', swatches);
    let $group = $("#swatch-container");
    $group.empty();

    Object.values(swatches)
      .filter((s) => {
        if (s.available && s.images.length > 0) return true;
      })
      .forEach((swatch, index) => {
        $group.append(
          $(`
            <li id="swatch-container-${this.getSwatchSlug(
            swatch.name
          )}" in-stock="available" class="swatch-element color solids ${this.getSwatchSlug(
            swatch.name
          )} available" originating-product="Fendrick Top - Lights" data-value="${swatch.name
            }" data-price="" data-variant="">
              <input id="swatch-${this.getSwatchSlug(
              swatch.name
            )}" type="radio" name="color-input" value="${swatch.name
            }" data-swatch-tab="${tabHandle}">
              <label for="swatch-${this.getSwatchSlug(
              swatch.name
            )}" rel="tipsy" original-title="${swatch.name}">
                  <span class="offscreen">${swatch.name}</span>
              </label>
              ${swatch.isOnSale
              ? `<span class="swatch__sale-icon" aria-label="Sale Icon">%</span>`
              : ""
            }
            </li>
          `)
        );
        // TODO: add deep linking check here
        if (index === 0 && !this.selectedVariant) {
          $(`#swatch-${this.getSwatchSlug(swatch.name)}`).prop("checked", true);
          this.checkSwatches();
        } else if (
          this.selectedVariant &&
          this.selectedVariant.swatch === swatch.name
        ) {
          $(`#swatch-${this.getSwatchSlug(swatch.name)}`).prop("checked", true);
          this.checkSwatches();
          this.updateCarousel();
        }
      });
    const $swatches = $("li.swatch-element.color");
    this.applySwatches($swatches, "label");
  }

  applySwatches(swatches, applyToSelector) {
    swatches.each(function (index, swatch) {
      const swatchColorAttribute = swatch.dataset.value;
      const swatchColors = swatchColorAttribute.split(" & ");

      const swatchHexes = swatchColors.map(function (name) {
        return colors[name] || "#000";
      });

      let bg;

      if (swatchHexes.length === 1) {
        bg = swatchHexes[0];
      } else if (swatchHexes.length === 2) {
        bg = `linear-gradient(135deg, ${swatchHexes[0]} 50%, ${swatchHexes[1]} 50%)`;
      } else if (swatchHexes.length === 3) {
        bg = `linear-gradient(135deg, ${swatchHexes[0]} 40%, ${swatchHexes[1]} 40%, ${swatchHexes[1]} 60%, ${swatchHexes[2]} 60%)`;
      }

      $(swatch).find(applyToSelector).css("background", bg);
    });
  }

  checkSwatches() {
    // get current swatch

    let $selectedSwatchInput = $("input[name='color-input']:checked");
    let selectedSwatchColor = $selectedSwatchInput.val();
    let selectedSwatchTab = $selectedSwatchInput.data("swatch-tab");
    let $selectedSizeInput = $("input[name='size-input']:checked");
    let selectedSize = $selectedSizeInput.val();
    let tab = this.tabs[selectedSwatchTab];
    this.selectedSize = selectedSize;
    let previousSwatchName = this.selectedVariant
      ? this.selectedVariant.swatch
      : null;
    this.selectedVariant = null;
    let $addToCartBtn = $(".add-to-cart.add-to-cart-button");
    if (selectedSize && selectedSwatchColor) {
      this.selectedVariant = this.variants[
        `${selectedSwatchColor}-${selectedSize}`
      ];
      // unavailable === variant + size combo doesn't exist
      let unavailable = false;
      let swatchVariants;

      if (!this.selectedVariant) {
        unavailable = true;
        swatchVariants = this.getSwatchVariants(
          selectedSwatchTab,
          selectedSwatchColor
        );
        swatchVariants.forEach((sw) => {
          if (sw && !this.selectedVariant) {
            this.selectedVariant = sw;
          }
        });
      }

      swatchVariants = this.getSwatchVariants(
        selectedSwatchTab,
        this.selectedVariant.swatch
      );
      $addToCartBtn.attr("variant-id", this.selectedVariant.id);
      let $priceIndicator = $("span.price-item.price-item--regular");
      this.$submitBtn.prop("disabled", false);
      this.$submitBtn.attr("value", "Add to Cart");
      $(".notify-restock-container").hide();

      $("#size-container li").addClass("soldout");
      swatchVariants.forEach((swatch) => {
        if (!swatch) {
          return;
        }
        if (swatch.available) {
          $(`#size-container-${this.getSwatchSlug(swatch.size)}`).removeClass(
            "soldout"
          );
        } else {
          $(`#size-container-${this.getSwatchSlug(swatch.size)}`).addClass(
            "soldout"
          );
          if (selectedSize === swatch.size) {
            this.$submitBtn.prop("disabled", true);
            this.$submitBtn.attr("value", "Unavailable");
            $(".notify-restock-container").show();
          }
        }
      });

      if (unavailable) {
        this.$submitBtn.prop("disabled", true);
        this.$submitBtn.attr("value", "Unavailable");
      }

      if (this.selectedVariant.isOnSale) {
        $priceIndicator.html(
          this.getSaleLabel(
            "€" + this.selectedVariant.price,
            "€" + this.selectedVariant.oldPrice
          )
        );
      } else {
        $priceIndicator.html("<span class='money'>€" + this.selectedVariant.price + "</span>");
      }
      if (previousSwatchName !== this.selectedVariant.swatch) {
        this.updateCarousel();
      }
      $(".product-details.panel > .inner-panel").html(
        this.selectedVariant.product.body_html
      );
      let pageUrl = `?variant=${this.selectedVariant.id}`;
      if (this.updateUrlAllowed) {
        window.history.replaceState("", "", pageUrl);
      }
    }
    $("#swatch-indicator").text(selectedSwatchColor);
    $("#size-indicator").text(selectedSize);
  }

  getSwatchVariants(tabName, swatchName) {
    let sizes = this.tabs[tabName].sizes;
    let variants = [];
    Object.values(sizes).forEach((size) => {
      variants.push(this.variants[`${swatchName}-${size.name}`]);
    });
    return variants;
  }

  makeSizes(sizes) {
    $container = $("#size-container");
    $container.empty();
    sizes.forEach((size, index) => {
      let handle = this.getSwatchSlug(size.name);
      let $size = $(`
          <li id="size-container-${handle}" class="swatch-element size ${size.name} available" data-value="${size.name}">
              <input id="swatch-${handle}" type="radio" name="size-input" value="${size.name}">
              <label for="swatch-${handle}">
                  ${size.name}
                  <span class="crossed-out" title="Not available in this option"></span>
              </label>
          </li>
          `);
      $container.append($size);
      if (this.selectedVariant && this.selectedVariant.size === size.name) {
        $(`#swatch-${handle}`).prop("checked", true);
      } else if (
        this.selectedSize === size.name ||
        (index === 0 && !this.selectedSize)
      ) {
        $(`#swatch-${handle}`).prop("checked", true);
      }
    });
  }

  getProductData(callback) {
    $.ajax({
      method: "GET",
      url: "/collections/" + this.collectionHandle + "/products.json",
    }).then(function (res) {

      let data = {},
        variants = {};

      res.products.forEach((product) => {

        let type = "solids";
        const handle = product.handle;

        product.variants.forEach((v) => {
          v.options = [];
          if (v.option1) {
            v.options.push(v.option1);
          }
          if (v.option2) {
            v.options.push(v.option2);
          }
          if (v.option3) {
            v.options.push(v.option3);
          }
          v.public_title = `${v.option1}  / ${v.option2}`;
          v.name = `${product.title} - ${v.public_title}`;
          // if it's sold out, need these data points for the BIS plugin
          v.inventory_quantity = 0;
          v.inventory_management = "shopify";
          v.inventory_policy = "deny";
        });

        let productJson = JSON.stringify(product);

        if (
          handle.indexOf("-prints") > -1 ||
          handle.indexOf("-patterns") > -1
        ) {
          type = "prints";
        } else if (handle.indexOf("-contrasts") > -1) {
          type = "contrasts";
        }

        if (!data[type]) {
          data[type] = {
            handle: type,
            // Uppercase the first letter:
            name: type.charAt(0).toUpperCase() + type.substring(1),
            swatches: {},
            sizes: {},
          };
        }

        let sizeOptionKey = "option1";
        let swatchOptionKey = "option2";

        // Look up variant option keys
        product.options.forEach((opt) => {
          const COLOR = ['Color', 'Farbe', 'Barva', 'Couleur'];
          const SIZE = ['Size', 'Große', 'Velikost', 'Taille'];
          if (COLOR.includes(opt.name)) {
            swatchOptionKey = `option${opt.position}`;
            opt.values.forEach((val) => {
              if (!data[type].swatches[val]) {
                data[type].swatches[val] = {
                  name: val,
                  available: false,
                  images: [],
                };
              }
            });
          } else if (SIZE.includes(opt.name)) {
            sizeOptionKey = `option${opt.position}`;
            opt.values.forEach((val) => {
              if (!data[type].sizes[val]) {
                data[type].sizes[val] = {
                  name: val,
                };
              }
            });
          }
        });

        product.variants.forEach((variant) => {
          const swatch = variant[swatchOptionKey];
          const size = variant[sizeOptionKey];

          const isOnSale = (variant) => variant.compare_at_price &&
            variant.compare_at_price !== variant.price
            ? true
            : false;

          variant = {
            ...variant,
            size,
            swatch,
            tab: type,
            oldPrice: variant.compare_at_price,
            product,
            productJson,
            isOnSale: isOnSale(variant)
          }

          variants[`${swatch}-${size}`] = variant;

          // we need to ignore swatches not avail
          if (variant.available && data[type].swatches[swatch]) {
            data[type].swatches[swatch].available = true;
          }
          if (variant.isOnSale && data[type].swatches[swatch]) {
            data[type].swatches[swatch].isOnSale = true;
          }

          if (
            variant.featured_image &&
            variant.featured_image.src &&
            data[type].swatches[swatch]
          ) {
            if (
              data[type].swatches[swatch].images.filter(
                (img) => img.src === variant.featured_image.src
              ).length === 0
            ) {
              let filename = variant.featured_image.src;
              variant.featured_image.thumb =
                filename.substring(0, filename.lastIndexOf(".")) +
                "_160x" +
                filename.substring(filename.lastIndexOf("."));
              variant.featured_image.large =
                filename.substring(0, filename.lastIndexOf(".")) +
                "_1120x" +
                filename.substring(filename.lastIndexOf("."));
              data[type].swatches[swatch].images.push(variant.featured_image);
            }
          }
        });
      });

      // Check to see if there are empty tabs
      Object.keys(data).forEach((entry) => {
        data[entry].available = false;
        Object.values(data[entry].swatches).forEach((sw) => {
          if (sw.available) {
            data[entry].available = true;
          }
        });
        // Delete any tabs that are entirely sold out
        if (!data[entry].available) {
          // delete variant reference
          Object.values(data[entry].sizes).forEach((size) => {
            Object.keys(data[entry].swatches).forEach((sw) => {
              if (variants[`${data[entry].swatches[sw].name}-${size.name}`]) {
                delete variants[
                  `${data[entry].swatches[sw].name}-${size.name}`
                ];
              }
            });
          });
          // delete tab
          delete data[entry];
        }
      });

      callback({
        tabs: data,
        variants,
      });
    });
  }

  addListeners() {
    $(".product_form").on("keyup change paste", "input", () => {
      this.updateUrlAllowed = true;
      this.checkSwatches();
    });

    // Product QTY + - logic
    $(".qty .plus").on("click", () => {
      let qty = parseInt($(".qty-num").val());
      let newQty = qty + 1;
      $(".qty-num").val(newQty);
    });

    $("#bis-form").on("submit", (e) => {
      e.preventDefault();
      if (!this.selectedVariant) return;

      const url = "https://a.klaviyo.com/api/v1/catalog/subscribe";
      const email = $('#bis-form [name="email"]').val();
      const data = `a=M2nZNB&email=${email}&variant=${this.selectedVariant.id}&platform=shopify`;

      $.ajax({
        method: "POST",
        url: url,
        data: data,
        crossDomain: true,
        contentType: "application/x-www-form-urlencoded",
        responseType: "json",
      }).always((data) => {
        $('.jquery-modal').hide()
      });
    });

    $(".qty .minus").on("click", () => {
      let qty = parseInt($(".qty-num").val());
      qty--;
      if (qty < 1) {
        $(".qty-num").val(1);
      } else {
        $(".qty-num").val(qty);
      }
    });

    $(".product_form").on("submit", (e) => {
      e.preventDefault();
      if (this.selectedVariant && this.selectedVariant.id) {
        let quantity = $("input[name='quantity']").val();
        this.ajaxPost(this.selectedVariant.id, quantity);
        $("input[name='quantity']").val(1);
      }
    });

    $(document).on("click", ".product__image__thumbs a", (event) => {
      event.preventDefault();

      let videoLoaded = $("video").length;
      if (videoLoaded) {
        $("video").get(0).pause();
        $("video").get(1).pause();
      }

      if (this.currentCarousel) {
        this.currentCarousel.slideToLoop($(event.currentTarget).index());
      }
    });

    $(this.container).find(".product_form").attr("action", "/cart/add");

    $(window).resize(
      $.debounce(50, () => {
        this.resize();
      })
    );

    $(document)
      .on("click", ".swiper-wrapper img", (event) => {
        event.preventDefault();
        this.positionZoomImage(event.offsetX, event.offsetY);
        this.activateZoomImage($(event.currentTarget).attr("src"));
      })
      .bind(this);

    $(".zoom-image").on("click", this.deactivateZoomImage);
    this.$zoomImage = $(".zoom-image");

    this.$zoomImage
      .mousemove((event) => {
        this.positionZoomImage(event.offsetX, event.offsetY);
      })
      .bind(this);

    // Setup Details and Shipping Details accordions
    let acc = document.getElementsByClassName("accordion");
    let i;

    for (i = 0; i < acc.length; i++) {
      acc[i].addEventListener("click", function () {
        this.classList.toggle("active");
        let panel = this.nextElementSibling;
        if (panel.style.maxHeight) {
          panel.style.maxHeight = null;
        } else {
          panel.style.maxHeight = panel.scrollHeight + "px";
        }
      });
    }

    // get current variant id
    let regex = new RegExp("[\\?&]variant=([^&#]*)");
    let results = regex.exec(location.search);
    if (results !== null) {
      let currentVariantId = decodeURIComponent(results[1].replace(/\+/g, " "));

      //reset inventory message
      let inventory_item = $(".inventory-container").find(
        "[data-id='" + currentVariantId + "']"
      );
      let inventoryDiv = $(inventory_item[0]).clone();
      $(".inventory-alternate").html(inventoryDiv);
    }

    // update inventory message when swatch changes
    $("body").on("change", ".swatch-element", function () {
      // get current variant id
      let regex = new RegExp("[\\?&]variant=([^&#]*)");
      let results = regex.exec(location.search);
      if (results !== null) {
        let currentVariantId = decodeURIComponent(
          results[1].replace(/\+/g, " ")
        );

        // reset inventory message
        let inventory_item = $(".inventory-container").find(
          "[data-id='" + currentVariantId + "']"
        );
        let inventoryDiv = $(inventory_item[0]).clone();
        $(".inventory-alternate").html(inventoryDiv);
      }

      // update print collection
      let $selectedSwatchInput = $("input[name='color-input']:checked");
      let $selectedSwatchInputColor = $selectedSwatchInput.val();

      //---------remove print collection content
      $(".product-print-collection__wrapper").hide();
      $(".product-print-collection-body").owlCarousel("destroy");
      $(".product-print-collection-body").empty();

      if (window.print_products) {
        let print_product_limit = 4;
        let iterator = 1;

        //---------draw print collection content
        window.print_products.every(function (print_product) {
          if (iterator > print_product_limit) {
            return false;
          }

          print_product_slug = print_product.slug;

          print_product.variants.every(function (variant) {
            if (
              variant.option1 == $selectedSwatchInputColor &&
              variant.id != currentVariantId
            ) {
              iterator++;

              let productLink =
                "/products/" + print_product_slug + "?variant=" + variant.id;

              $(".product-print-collection-body").append(`
              <div class="product-print-collection_item">
                <a href="${productLink}">
                  <div class="product-print-collection_item_image" style="background-image: url(${Shopify.resizeImage(
                variant.featured_image_src,
                "x200"
              )})"></div>
                  
                  <div class="product-print-collection_item_content">
                    <div class="product-print-collection_item_title">
                      ${print_product.title}
                    </div>

                    <div class="product-print-collection_item_price">
                      ${Shopify.formatMoney(variant.price)}
                    </div>
                  </div>
                </a>
              </div>
            `);

              $(".product-print-collection__wrapper").show();

              return false;
            }

            return true;
          });

          return true;
        });

        let owlConfig = {
          items: 4,
          autoWidth: false,
          lazyLoad: true,
          loop: true,
          margin: 30,
          nav: true,
          dots: false,
          responsive: {
            0: {
              items: 1,
            },
            375: {
              items: 2,
              margin: 60,
            },
            767: {
              items: 3,
            },
            992: {
              items: 4,
            },
          },
        };

        $(".product-print-collection-body").owlCarousel(owlConfig);
      }
    });
  }

  resize() {
    const $carousel = $(".product__image");
    let vpWidth = $(window).width();
    if (vpWidth > 767) {
      $carousel.appendTo($("#desktop-carousel"));
    } else {
      $carousel.appendTo($("#mobile-carousel"));
    }
  }

  map(input, in_min, in_max, out_min, out_max) {
    return (
      ((input - in_min) * (out_max - out_min)) / (in_max - in_min) + out_min
    );
  }

  positionZoomImage(x, y) {
    const maxX = this.$zoomImage.innerWidth();
    const maxY = this.$zoomImage.innerHeight();
    let scaledX = this.map(x, 0, maxX, 0, 100);
    let scaledY = this.map(y, 0, maxY, 0, 100);
    this.$zoomImage.css({
      "background-position": `${scaledX}% ${scaledY}%`,
    });
  }
  activateZoomImage(url) {
    $(".zoom-image")
      .css({
        "pointer-events": "auto",
        opacity: 1,
        "background-image": `url('${url}')`,
      })
      .mousemove();
  }

  deactivateZoomImage() {
    $(".zoom-image")
      .css({
        "pointer-events": "none",
        opacity: 0,
      })
      .mousemove();
  }

  buildVariantMap(variantJson) {
    let flatVariants = variantJson.flat(2);
    let variantIds = [
      ...new Set(flatVariants.map((variant) => variant.variantId)),
    ];

    return (variantMap = variantIds.map((variant) => {
      let values = flatVariants.filter((e) => e.variantId == variant);
      return {
        size: values[0].size,
        color: values[1].color,
        image: values[0].image,
        price: values[0].price,
        available: values[0].available === "true",
        oldPrice: values[0].oldPrice,
        isOnSale: values[0].isOnSale === "true",
        variant,
      };
    }));
  }

  addSwatchesToContainer(colorTabIdList) {
    colorTabIdList.forEach(function (id) {
      $(`[swatch-color-tab="${id}"]`)
        .detach()
        .appendTo(`[color-tab-id="${id}"]`);
    });
    $(".swatch-element.size").detach().appendTo(".size-list");
  }

  setImgThumbs(imgObjs, color) {
    $(".img-slide.all_thumb").hide();
    // $(`.img-slide.all_thumb:lt(${imgObjs.length})`).css("display", "block");
    if (color) {
      color = this.getSwatchSlug(color);
      $(`.img-slide.all_thumb.${color}`).css("display", "block");
    }
  }

  listCategories() {
    let categories = [];
    $(".color-swatch__tab-opener").each(function (i, item) {
      categories.push(
        $(item)
          .text()
          .replace(/ /g, "")
          .replace(/(?:\r\n|\r|\n)/g, "")
      );
    });
    let phrase = categories
      .reduce(function (prev, curr, i) {
        return prev + curr + (i === categories.length - 2 ? " or " : ", ");
      }, "")
      .slice(0, -2);
    $(".color-swatch__tab-header").text("Select: " + phrase);
  }

  updateCarousel() {
    if (!this.selectedVariant) {
      return;
    }

    let swatch = this.tabs[this.selectedVariant.tab].swatches[
      this.selectedVariant.swatch
    ];
    let swatchImages = swatch.images;

    if (this.currentCarousel && this.currentCarousel.destroy) {
      this.currentCarousel.destroy(true, true);
    }

    $(".product__image__photos").attr(
      "style",
      `width: ${$(".product__image__photos").width()}px`
    );
    $(".product__image__thumbs").empty();
    $(".product__image__photos").empty();
    $(".product__image__photos").append(
      $('<div class="swiper-wrapper"></div>')
    );
    $(".product-button-prev").hide();
    $(".product-button-next").hide();

    swatchImages.forEach((img) => {
      if (swatchImages.length > 0) {
        $(".product__image__thumbs").append(
          $(
            `<a href="#" aria-label="Jump to image">
            <img src="${img.thumb}" alt="${img.color}">
          </a>`
          )
        );
      }

      $(".swiper-wrapper").append(
        $(
          `<div class="swiper-slide product__image__photos--slide">
          <img src="${img.large}" class="" alt="${img.color}">
        </div>`
        )
      );
    });

    let variant_image_message_selector = $(
      ".variant_metafield[data-variant-id=" + this.selectedVariant.id + "] span"
    );
    let variant_image_message = "";

    if (variant_image_message_selector.length > 0) {
      variant_image_message = variant_image_message_selector[0].innerText;
    }

    $(".variant_image_message").text(variant_image_message);

    let productID = this.selectedVariant.product.id;
    let productMetafield = $(".product_metafields").find(
      "[data-product-id=" + productID + "]"
    );

    if (productMetafield.length > 0) {
      let productVideoThumbnail = $(
        $(productMetafield[0]).find(".product_metafield__video_thumbnail")[0]
      ).data("video-thumbnail");
      let productVideoUrl = $(
        $(productMetafield[0]).find(".product_metafield__video_url")[0]
      ).data("video-url");
      let productVideoModel = $(productMetafield[0]).find(
        ".product_metafield__video_model"
      )[0];
      $(".product__image__thumbs").append(
        $(
          '<a href="#" aria-label="Jump to image"><img\n            src="'
            .concat(productVideoThumbnail, '" alt="')
            .concat(
              "\"><svg width='30pt' height='30pt' version='1.1' viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg' style='position: absolute; left: 20px; bottom: 40px; fill: #fff;'><path d='m50 12c-20.988 0-38 17.012-38 38s17.012 38 38 38 38-17.012 38-38-17.012-38-38-38zm-11 20l30 18-30 18z'></path></svg></a>"
            )
        )
      );
      if (productVideoModel) {
        productVideoModel = productVideoModel.innerText;
        $(".swiper-wrapper").append(
          $(
            '<div class="swiper-slide product__image__photos--slide"><video controls style="width:100%; cursor: default;" poster="'.concat(
              productVideoThumbnail,
              '"><source src="'.concat(
                productVideoUrl,
                '" type=\'video/mp4\' /></video><div style="font-size: 12px; cursor: default; text-align: center;">' +
                productVideoModel +
                "</span></div>"
              )
            )
          )
        );
      } else {
        $(".swiper-wrapper").append(
          $(
            '<video controls class="swiper-slide product__image__photos--slide" style="width:100%; cursor: default; text-align: centerl;" poster="'.concat(
              productVideoThumbnail,
              '"><source src="'.concat(
                productVideoUrl,
                "\" type='video/mp4' /></video>"
              )
            )
          )
        );
      }
    }

    this.currentCarousel = new Swiper(".product__image__photos", {
      slidesPerView: 1,
      speed: 500,
      loop: swatchImages.length > 0 ? true : false,
      direction: "horizontal",
      navigation: {
        nextEl: ".product-button-next",
        prevEl: ".product-button-prev",
      },
      on: {
        imagesReady: () => {
          this.loadPlugins();
          $(".product-template-alt").css({ opacity: 1 });
          if (swatchImages.length > 0) {
            $(".product-button-prev").show();
            $(".product-button-next").show();
          }
          $(".product__image__photos").attr("style", "");
          if (this.currentCarousel && this.currentCarousel.update) {
            this.currentCarousel.update();
          }
        },
      },
    });
    $(".product__image").hide();
    setTimeout(() => {
      if (this.currentCarousel && this.currentCarousel.update) {
        this.currentCarousel.update();
      } else {
        setTimeout(() => {
          this.currentCarousel.update();
        }, 1500);
      }
      $(".product__image").fadeIn();
    }, 300);
    //$('.product__image__photos').css({ width: null });

    // pairswith app
    // $.ajax({
    //   method: "GET",
    //   url:
    //     "https://pairswith.app/products/getImages?variant_id=" +
    //     this.selectedVariant.id,
    // }).then(function (res) {
    //   metafields = res.images;
    //   direction = res.position_flag;
    //   let handles = res.handles;
    //   let prices = res.prices;
    //   let titles = res.titles;

    //   if (metafields.length != 0) {
    //     let image_add = metafields.split(",");
    //     let handle_add = handles.split(",");
    //     let price_add = prices.split(",");
    //     let title_add = titles.split(",");

    //     if (direction == 1) {
    //       $("#top-image").empty();
    //       $("#top-image").append(
    //         $(
    //           '<img src="'
    //             .concat(
    //               swatchImages[0].medium,
    //               '" class="swiper-slide product__image__photos--slide" alt="'
    //             )
    //             .concat(
    //               swatchImages[0].color,
    //               '"><div class="current-product">This product</div>'
    //             )
    //         )
    //       );
    //     } else {
    //       $("#bottom-image").empty();
    //       $("#bottom-image").append(
    //         $(
    //           '<img src="'
    //             .concat(
    //               swatchImages[0].large,
    //               '" class="swiper-slide product__image__photos--slide" alt="'
    //             )
    //             .concat(
    //               swatchImages[0].color,
    //               '"><div class="current-product">This product</div>'
    //             )
    //         )
    //       );
    //     }

    //     $("#slideshow .slick").slick("unslick");
    //     $("#slideshow .slick").empty();

    //     for (let i = 0; i < image_add.length; i++) {
    //       $("#slideshow .slick").append(
    //         $(
    //           "<div><a href='/products/" +
    //           handle_add[i] +
    //           "'><img src='" +
    //           image_add[i] +
    //           '\' ><div class="product-info"><p class="product-name">' +
    //           title_add[i] +
    //           '</p><p class="product-price">$' +
    //           price_add[i] +
    //           "</p></div></a></div>"
    //         )
    //       );
    //     }

    //     $("#slideshow .slick").slick();
    //   } else {
    //     $("#slideshow .slick").slick("unslick");
    //     $("#slideshow .slick").empty();
    //     $("#top-image").empty();
    //     $("#bottom-image").empty();
    //   }
    // });
  }

  getUrlParameter(name) {
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    let regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
    let results = regex.exec(location.search);
    return results === null
      ? ""
      : decodeURIComponent(results[1].replace(/\+/g, " "));
  }

  /**
   *  Get element from variantMap
   */
  findElement(size, color, variantMap) {
    return variantMap.find(function (element) {
      return element["size"] == size && element["color"] == color;
    });
  }

  findElementBySwatch(color, variantMap) {
    return variantMap.find(function (element) {
      return element["color"] == color;
    });
  }

  findSwatchSizes(color, variantMap) {
    return variantMap.filter(function (element) {
      return element["color"] == color;
    });
  }

  findParentTabName(_variantId) {
    let tabName;
    let variantId = parseInt(_variantId, 10);
    for (let key in productParentProductData) {
      if (productParentProductData.hasOwnProperty(key)) {
        productParentProductData[key].variants.forEach((varient) => {
          if (varient.id === variantId) {
            tabName = key;
          }
        });
      }
    }
    return tabName;
  }

  findColorElements(color, variantMap) {
    let objs = [];

    variantMap.map(function (element) {
      if (element["color"] == color) {
        objs.push(element);
      }
    });

    let images = [...new Set(objs.map((variant) => variant.image))];

    return images;
  }

  ajaxPost(id, quantity) {
    let a = $(this);
    $.ajax({
      type: "POST",
      url: "/cart/add", // Send the login info to this page
      data: {
        quantity: "" + quantity,
        id: "" + id,
      },
      dataType: "jsonp",
      timeout: 200000,
      error: function (t) {
        Shopify.getCart(function (e) {
          let box = $("#cart-box");
          box.find(".product-link").attr("href", t.url),
            box
              .find(".product-img")
              .attr("src", Shopify.resizeImage(t.image, "medium"))
              .attr("alt", ""),
            box.find(".product-title .product-link").html("title"),
            box
              .find(".product-price")
              .html(Shopify.formatMoney(t.price, money_format)),
            //          frontendData.enableCurrency && currenciesCallbackSpecial("#cart-box span.money");
            setTimeout(function () {
              $(".loader-container").hide();
              $("#resultLoading").hide();
              box.addClass("show");
              $(".mini-cart .cart-wrapper").show("show");
              setTimeout(function () {
                box.removeClass("show");
                $(".mini-cart .cart-wrapper").hide("show");
              }, 5e3);
            }, 500),
            SW.collection.updateCartInfo(
              e,
              ".cart-container .cart-wrapper .cart-inner-content"
            );
        });
        return false;
      },
      success: function (t) {
        Shopify.getCart(function (e) {
          let box = $("#cart-box");
          box.find(".product-link").attr("href", t.url),
            box
              .find(".product-img")
              .attr("src", Shopify.resizeImage(t.image, "medium"))
              .attr("alt", ""),
            box.find(".product-title .product-link").html("title"),
            box
              .find(".product-price")
              .html(Shopify.formatMoney(t.price, money_format)),
            //          frontendData.enableCurrency && currenciesCallbackSpecial("#cart-box span.money");
            setTimeout(function () {
              $(".loader-container").hide();
              $("#resultLoading").hide();
              box.addClass("show");
              $(".mini-cart .cart-wrapper").show("show");
              setTimeout(function () {
                box.removeClass("show");
                $(".mini-cart .cart-wrapper").hide("show");
              }, 5e3);
            }, 500),
            SW.collection.updateCartInfo(
              e,
              ".cart-container .cart-wrapper .cart-inner-content"
            );
        });
        return false;
      },
    });
  }

  openTab(tabName, clickFirstSwatch) {
    let $tabOpeners = $(".color-swatch__tab-opener");
    let $tab = $(`[color-tab-opener="${tabName}"]`);
    let $tabVariantContainers = $(".variants-container.color-list");
    let $thisTabVariantContainer = $(`[color-tab-id="${tabName}"]`); //current color grouping
    if (clickFirstSwatch) {
      let $firstLabel = $thisTabVariantContainer
        .find("li")
        .first()
        .find("label");
      $firstLabel.trigger("click");
    }
    $tabOpeners.attr("aria-pressed", false);
    $tabOpeners.removeClass("active"); // Make all tabs inactive
    $tab.addClass("active"); // Make clicked on tab active
    $tab.attr("aria-pressed", true);
    $tabVariantContainers.hide(); // Make all containers inactive
    $thisTabVariantContainer.css("display", "flex"); // Make current grouping container active
  }

  getSwatchSlug(swatchName) {
    let updated = swatchName
      .toLowerCase()
      .replace(/ & /g, " ")
      .replace(/&/g, " ");
    updated.replace(/[^\w\u00C0-\u024f]+/g, "-").replace(/^-+|-+$/g, "");
    return updated.replace(/\//g, "-").replace(/ /g, "-");
  }

  additionalSetupRefactorThis() {
    let owlConfig = {
      items: 4,
      autoWidth: false,
      lazyLoad: true,
      loop: true,
      margin: 30,
      nav: true,
      dots: false,
      responsive: {
        0: {
          items: 1,
        },
        375: {
          items: 2,
          margin: 20,
        },
        767: {
          items: 3,
        },
        992: {
          items: 4,
        },
      },
    };

    waitForEl(
      ".you-may-also-like .recommendify-panel-body",
      function () {
        $(".you-may-also-like .recommendify-panel-body").owlCarousel(owlConfig);
      },
      20,
      200
    );

    waitForEl(
      ".recently-viewed .recommendify-panel-body",
      function () {
        $(".recently-viewed .recommendify-panel-body").owlCarousel(owlConfig);
      },
      20,
      200
    );

    // Wait for review stars
    waitForEl(
      ".stamped-summary .stamped-starrating.stamped-summary-starrating",
      function () {
        let realStars = $(
          ".stamped-summary .stamped-starrating.stamped-summary-starrating"
        ).clone();
        $(
          ".read-reviews .stamped-starrating.stamped-summary-starrating"
        ).replaceWith(realStars);
      }
    );
  }

  loadPlugins() {
    if (!this.pluginsLoaded) {
      this.pluginsLoaded = true;
      this.additionalSetupRefactorThis();
      waitForEl(
        ".stamped-container",
        function () {
          let reviewCount = $(".stamped-container").attr("data-count");
          $(".read-reviews .count").text(reviewCount);
          $(".read-reviews-mobile .count").text(reviewCount);
          if (Number(reviewCount) > 0) {
            $(".read-reviews").css({ opacity: 1 });
          }
        },
        20,
        200
      );
    }
  }

  getSaleLabel(price, oldPrice) {
    return $(`<dl class="price price--on-sale" data-price="">
      <div class="price__regular"> 
        <dt>
          <span class="visually-hidden visually-hidden--inline">Regular price</span>
        </dt>
        <dd>
          <span class="price-item price-item--regular" data-regular-price="${oldPrice}">
            <span class="money">
                ${oldPrice}
              </span>
          </span>
        </dd>
      </div>
      <div class="price__sale">
        <dt>
          <span class="visually-hidden visually-hidden--inline">Sale price</span>
        </dt>
        <dd>
          <span class="price-item price-item--sale" data-sale-price="${price}">
            <span class="money">
              ${price}
            </span>
          </span>
          <span class="price-item__label" aria-hidden="true">Sale</span>
        </dd>
      </div>
    </dl>`);
  }
}

const container = document.querySelector(".product-template-alt");
if (container) {
  new ProductParent(container);
}
